import { type GetProps, Separator, type SpaceTokens, styled } from "tamagui";
export const Divider = styled(Separator, {
  borderColor: "$uiStroke",
  alignSelf: "stretch",
  variants: {
    thin: {
      true: (_val, {
        props
      }) => ({
        [props.vertical ? "borderRightWidth" : "borderBottomWidth"]: "$space.border1"
      }),
      false: (_val, {
        props
      }) => ({
        [props.vertical ? "borderRightWidth" : "borderBottomWidth"]: "$space.border2"
      })
    },
    indent: (val: SpaceTokens, {
      props
    }) => ({
      [props.vertical ? "marginVertical" : "marginHorizontal"]: val
    })
  } as const,
  defaultVariants: {
    thin: false
  }
});
export type DividerProps = GetProps<typeof Divider>;